import React from 'react';
import './Works.css';
import Workscard from './Workscard.js';
import Footer from './Component/footer'

const Works = () => {
    const Works = {
        color: "white",
     
    }
    
    return (
        <div style={Works} className="" id="maincontainer">
        <div className="wcontainer">
         <h2 className="heading">Works</h2>
         
         <p className="bio"> I follow a user centred design approach To my work 
         by aligning your business goals and objectives with the needs
          of your users. I use empathy as a core tool in my User
          Experience design to help me create design solutions
           that are beneficial to users.</p>
        </div>

        <Workscard />   
        
        <Footer /> 
  
            </div>
    )
}


export default Works